import { type SbAsset } from "@krakentech/blueprint-utils/storyblok"
import {
    type SbBlok,
    type SbBlokDataReturnType,
    type SbContentTypeDataReturnType,
    type SbStoryReturnType,
} from "../types"

type SbUniversalBlok = SbBlokDataReturnType | SbContentTypeDataReturnType

function isSbUniversalBlok(blok: object | string): blok is SbUniversalBlok {
    return typeof blok === "object" && "component" in blok
}

function parseContentTypeAndBlok(
    content: SbUniversalBlok | SbBlokDataReturnType[] | string[] | SbAsset[] | SbStoryReturnType[],
    blokCallback: (_blok: SbUniversalBlok) => void
) {
    if (Array.isArray(content)) {
        for (const child of content) {
            if (isSbUniversalBlok(child)) parseContentTypeAndBlok(child, blokCallback)
        }
    } else if (typeof content === "object") {
        blokCallback(content)

        Object.values(content).forEach((fieldValue: SbUniversalBlok) => {
            if (fieldValue && Array.isArray(fieldValue)) {
                parseContentTypeAndBlok(fieldValue, blokCallback)
            }
        })
    }
}

export function hasBlokInContent(content: SbUniversalBlok, blok: SbBlok) {
    let hasBlok = false

    parseContentTypeAndBlok(content, (_blok) => {
        if (_blok.component === blok) hasBlok = true
    })

    return hasBlok
}
